import { Navigate, Outlet } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthContext'

// Arena is internal/admin-only: only signed-in users whose verified email is in
// an allowed domain (default meta.com) may see it. This mirrors the arena-api's
// require_admin gate (the API 403 is the real boundary; this just hides the route
// so regular users never see it). Local dev bypasses, like ProtectedRoute.
const ADMIN_DOMAINS = (import.meta.env.VITE_ARENA_ADMIN_EMAIL_DOMAINS || 'meta.com')
  .split(',')
  .map((d) => d.trim().toLowerCase())
  .filter(Boolean)

const isLocalDev =
  import.meta.env.DEV &&
  !import.meta.env.VITE_ENABLE_AUTH &&
  (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')

export function isArenaAdmin(email: string | null | undefined): boolean {
  if (!email || !email.includes('@')) return false
  return ADMIN_DOMAINS.includes(email.split('@').pop()!.toLowerCase())
}

export default function ArenaAdminRoute() {
  const { user, isLoading } = useAuth()
  if (isLoading) return null
  if (isLocalDev || isArenaAdmin(user?.email)) return <Outlet />
  return <Navigate to="/dashboard" replace />
}
